import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Image } from 'components/core/Image';
import { Section, Group, Row, Column, Container } from 'components/core/Page';
import { H2, Text } from 'components/core/Typography';

import coinStackDesktop from 'assets/images/landing/state-pages/coin-stack-desktop.svg';

import './StatePageEconomicOutlook.scss';

export default function StatePageEconomicOutlook({ state, economicOutlook }) {
	return (
		<Container className="state-page-economic-outlook">
			<Section className="economic-outlook-section">
				<Section className="illustration-container">
					<Image
						src={coinStackDesktop}
						className="state-page-illustration"
					/>
				</Section>
				<Section>
					<H2
						size="medium"
						color="black"
						className="state-page-title"
					>
						{state} Economic Outlook
					</H2>
				</Section>
				<Section>
					<div
						className={classnames('economic-outlook-copy', {
							'economic-outlook-subtitle':
								economicOutlook.breakdown,
						})}
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: economicOutlook.copy,
						}}
					/>
				</Section>
				<Group>
					{economicOutlook.breakdown &&
						economicOutlook.breakdown.map(({ sector, value }) => (
							<Group key={sector}>
								<Row className="sector-row">
									<Column
										large={2}
										className="value-column"
									>
										<Text
											color="green"
											size="medium"
											weight="extraLight"
											className="value"
										>
											{value}
										</Text>
									</Column>
									<Column
										large={4}
										className="sector-column"
									>
										<Text
											weight="light"
											color="black"
											className="sector"
										>
											{sector}
										</Text>
									</Column>
								</Row>
							</Group>
						))}
				</Group>
				<Group>
					<div
						className="economic-outlook-copy"
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: economicOutlook.bottomLine,
						}}
					/>
				</Group>
			</Section>
		</Container>
	);
}

StatePageEconomicOutlook.propTypes = {
	state: PropTypes.string.isRequired,
	economicOutlook: PropTypes.shape({
		copy: PropTypes.string.isRequired,
		breakdown: PropTypes.arrayOf(
			PropTypes.shape({
				sector: PropTypes.string,
				value: PropTypes.string,
			}),
		),
		bottomLine: PropTypes.string,
	}).isRequired,
};
